import Promise from 'core-js/library/fn/promise';
import Stickyfill from 'stickyfilljs';
import objectFitImages from 'object-fit-images';
import 'whatwg-fetch';
import 'classlist-polyfill';
import 'ie11-custom-properties';
import 'intersection-observer';

window.objectFitImages = objectFitImages;
window.Promise = Promise;

objectFitImages();

[].forEach.call(window.document.querySelectorAll('.has-sticky-content > div, .is-sticky'), Stickyfill.add);
